module.exports = __webpack_public_path__ + "img/user-14.470358ef.jpg";